import { useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import { useCreateRole, usePermissionList } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';

function AddRole() {
	const history = useHistory();
	const { permissionList, loading: permissionsLoading } = usePermissionList();
	const [createRole, { loading: creating }] = useCreateRole();

	const handleSubmit = async (values: RoleSubmitPayload) => {
		await createRole(values);
		history.push(getAppRoutes().ROLES);
	};

	if (permissionsLoading) return <Spin />;

	return (
		<PermissionList
			mode="add"
			permissionList={permissionList}
			loading={creating}
			onCancel={() => history.push(getAppRoutes().ROLES)}
			onSubmit={handleSubmit}
		/>
	);
}

export default AddRole;